export default "__VITE_ASSET__512a6IaN__"